// export const serverUrl = "http://localhost/server";
export const serverUrl = "https://metakindia.com/server";
